import { Material } from '../../../../sp-types';
import { INetExposure } from '../../../../sp-types/netExposureType';
import { getNetExposure } from '../../../../utils/exposureUtils';
import { convertDateToMonthYear, isEqualMonthYear, MonthYear } from '../../../../utils/MonthYear/monthYear';
import { MonthYearValue } from '../../../../utils/MonthYear/MonthYearValue';

export const getAdjustedMaterialsExposure = (
  totalExposure: { materialId: string; exposureCalendar: MonthYearValue[] }[],
  exposureData: INetExposure,
  materialsMap: Record<string, Material>,
  convertionMap: Record<string, number>,
  currentDate?: Date,
): Record<string, number> => {
  const date: MonthYear = convertDateToMonthYear(currentDate || new Date());

  return totalExposure.reduce((acc, item) => {
    acc[item.materialId] =
      getNetExposure(exposureData, convertionMap, item.materialId) -
      (item.exposureCalendar.find((item) => isEqualMonthYear(item.date, date))?.value || 0) *
        materialsMap[item.materialId].currentPrice *
        convertionMap[item.materialId];
    return acc;
  }, {} as Record<string, number>);
};
